import ConnectorClientView from './ConnectorClientView';

export default ConnectorClientView;
